import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WorksiteClient } from '../clients/oreg-api/worksite.client';
import { ListCompany } from '../models/list-company.model';
import { SearchResult } from '../models/search-result.model';

@Injectable({ providedIn: 'root' })
export class WorksitesQuery {
  constructor(private worksiteClient: WorksiteClient) {}

  search(
    companyNumber?: string,
    name?: string,
    city?: string,
    country?: string,
    worksiteNumber?: string,
    companyId?: string,
  ): Observable<SearchResult<ListCompany>> {
    return this.worksiteClient.searchWorksites(
      companyNumber,
      name,
      city,
      country,
      worksiteNumber,
      companyId,
    );
  }

  get(id: string) {
    return this.worksiteClient.getWorksite(id);
  }
}
